module.exports = __webpack_public_path__ + "img/IconBioLight.1b9d25b5.png";